import { Box, Button, Divider, Typography, useTheme, Autocomplete, TextField, Tooltip, Chip } from "@mui/material";
import { tokens, ColorModeContext } from "../../../theme";
import { useState, useEffect, useRef, useContext, useMemo } from "react";
import classes from "./data-program.module.css";

import { displayDate } from "../../../utils/format-suport/data-format";

import { faCheck, faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons";
import { faArrowDownShortWide } from "@fortawesome/free-solid-svg-icons";
import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useMediaQuery from "@mui/material/useMediaQuery";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

import Zoom from "@mui/material/Zoom";
// import CustomButton from "../../button";

import beans from "../../../utils/assets/icons/beans2.png";
import soy from "../../../utils/assets/icons/soy.png";
import rice from "../../../utils/assets/icons/rice.png";
import cotton from '../../../utils/assets/icons/cotton.png'
import corn from '../../../utils/assets/icons/corn.png'

import { faPrint } from "@fortawesome/free-solid-svg-icons";

import MapPage from "../maps";
import djangoApi from "../../../utils/axios/axios.utils";
import CircularProgress from "@mui/material/CircularProgress";
import Fade from "@mui/material/Fade";

import { useSelector } from "react-redux";
import { selectIsAdminUser } from "../../../store/user/user.selector";
import {
	selectPlantio,
	selectSafraCiclo
} from "../../../store/plantio/plantio.selector";

import EmptyResultPage from "./empty-result";

// import JsPDF from "jspdf"
// import moment from "moment";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

// import MapPlotDjango from "./data-plot-map";


import FarmIcon from '../../../utils/assets/icons/farmbox.svg'
import toast from "react-hot-toast";
import LinearProgress from "@mui/material/LinearProgress";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { createRoot } from "react-dom/client";


import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SelectCulturaVariedade from "./filter-select";


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import PlaylistRemoveRoundedIcon from "@mui/icons-material/PlaylistRemoveRounded";
import ContentPasteGoRoundedIcon from "@mui/icons-material/ContentPasteGoRounded";

import { fetchCaldaAvulsa, saveCaldaAvulsa, clearCaldaAvulsa as clearCaldaAvulsaFS } from "../../../utils/firebase/firebase.datatable.ordems"; // ajuste o path


const to3 = (v) => Number(v || 0).toFixed(3);

const normalizeDose = (s) => {
	const val = String(s ?? "").replace(",", ".").trim();
	const n = Number(val);
	if (!Number.isFinite(n) || n < 0) return null;
	return Number(to3(n));
};

const buildFarmboxInputFromProd = (prod, doseNum) => {
	const input_id = prod?.input_id ?? prod?.id_farmbox ?? prod?.id ?? null;
	const dosage_unity = prod?.dosage_unity ?? prod?.formulacao ?? prod?.dosageUnity ?? null;

	return {
		input_id,
		dosage_unity,
		dosage_value: Number(to3(doseNum)),
		produto: prod?.name || prod?.produto || "Insumo",
	};
};



const DataProgramPage = (props) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const colorMode = useContext(ColorModeContext);
	const { initialDateForm, finalDateForm, handleRefreshData } = props;

	const [farmList, setFarmList] = useState([]);
	const [objList, setObjList] = useState([]);
	const [objResumValues, setObjResumValues] = useState([]);
	const [filteredAndDucplicatedParcelas, setfilteredAndDucplicatedParcelas] = useState([]);

	const [filteredList, setFilteredList] = useState([]);
	const [farmSelected, setFarmSelected] = useState("");

	const [showProducts, setShoeProducts] = useState(true);
	const isNonIpad = useMediaQuery("(min-width: 1404px)");
	const isCellPhone = useMediaQuery("(min-width: 850px)");

	const [onlyOpenApp, setOnlyOpenApp] = useState(false);

	const [filtData, setFiltData] = useState(false);

	const [mapArray, setMapArray] = useState([]);
	// const [mapArrayIds, setMapArrayIds] = useState([]);
	const [dataToMap, setDataToMap] = useState([]);

	const [areaFiltTotal, setAreaFiltTotal] = useState(0);

	const [showMapps, setShowMapps] = useState(false);

	const [isLoadingHome, setIsLoading] = useState(true);

	const [updateApp, setUpdateApp] = useState([]);

	const [sendingData, setSendingData] = useState(false);
	const [positiveSignal, setPositiveSignal] = useState(false);

	const isAdminUser = useSelector(selectIsAdminUser);
	const plantioRedux = useSelector(selectPlantio);
	const safraCiclo = useSelector(selectSafraCiclo);

	const [hidenAppsArr, setHidenAppsArr] = useState([]);

	const [appsLoading, setAppsLoading] = useState([]);
	const [appsOpened, setAppsOpened] = useState([]);         // novos apps já abertos


	const [loadMaps, setLoadMaps] = useState(false);
	const [prodsToRemove, setProdsToRemove] = useState([]);
	const [prodsToAdd, setprodsToAdd] = useState([]);

	const [prodsToUse, setProdsToUse] = useState([]);
	const [isLoadingProdsToUse, setIsLoadingProdsToUse] = useState(false);

	const MySwal = withReactContent(Swal);

	const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

	const [culturaSelecionada, setCulturaSelecionada] = useState([]);
	const [variedadeSelecionada, setVariedadeSelecionada] = useState([]);
	const [parcelasSelecionada, setParcelasSelecionada] = useState([]);
	const [filterCultura, setFilterCultura] = useState([]);
	const [filterVariedade, setFilterVariedade] = useState([]);
	const [filterParcela, setFilterParcela] = useState([]);

	const [estagiosSelecionados, setEstagiosSelecionados] = useState([]);
	const [filterEstagios, setFilterEstagios] = useState([]); // opções do multiselect



	const [caldaAvulsa, setCaldaAvulsa] = useState([]); // sessão
	const [useCaldaAvulsaByApp, setUseCaldaAvulsaByApp] = useState({});

	// modal
	const [openCaldaModal, setOpenCaldaModal] = useState(false);

	// campos do modal
	const [caldaProd, setCaldaProd] = useState(null);
	const [caldaDose, setCaldaDose] = useState("");


	// =========================
	// Storage — Calda Avulsa (por fazenda)
	// =========================
	const [caldaSyncing, setCaldaSyncing] = useState(false);
	const [caldaLoaded, setCaldaLoaded] = useState(false);

	// evita salvar enquanto está carregando pela primeira vez
	const skipFirstSaveRef = useRef(true);
	const caldaInputRef = useRef(null);


	const isAppLoading = (appKey) => appsLoading.includes(appKey);

	const startAppLoading = (appKey) => {
		setAppsLoading((prev) =>
			prev.includes(appKey) ? prev : [...prev, appKey]
		);
	};

	const finishAppLoading = (appKey) => {
		setAppsLoading((prev) =>
			prev.filter((key) => key !== appKey)
		);
	};



	const sanitizeCaldaItem = (x) => {
		if (!x || typeof x !== "object") return null;

		const input_id = x.input_id ?? x.id_farmbox ?? null;
		if (!input_id) return null;

		const dosage_value = Number(String(x.dosage_value ?? x.dose ?? 0).replace(",", "."));
		if (!Number.isFinite(dosage_value) || dosage_value < 0) return null;

		const dosage_unity = (x.dosage_unity || x.formulacao || "").toString().trim() || null;
		const produto = (x.produto || x.name || "Insumo").toString();

		return {
			input_id,
			dosage_unity,
			dosage_value: Number(Number(dosage_value).toFixed(3)),
			produto,
		};
	};

	const normalizeUseByApp = (obj) => {
		if (!obj || typeof obj !== "object") return {};
		const out = {};
		for (const [k, v] of Object.entries(obj)) out[k] = !!v;
		return out;
	};




	const openMontarCalda = () => setOpenCaldaModal(true);
	const closeMontarCalda = () => {
		setOpenCaldaModal(false);
		setCaldaProd(null);
		setCaldaDose("");
	};

	const handleAddToCaldaAvulsa = () => {
		const doseNum = normalizeDose(caldaDose);
		if (!caldaProd) {
			toast.error("Selecione um insumo.");
			return;
		}
		if (doseNum == null) {
			toast.error("Dose inválida (use até 3 casas e >= 0).");
			return;
		}

		const input = buildFarmboxInputFromProd(caldaProd, doseNum);
		console.log('input: ', input)

		if (!input.input_id) {
			toast.error("Produto sem id_farmbox (input_id).");
			return;
		}

		setCaldaAvulsa((prev) => {
			// se já existe, atualiza dose (em vez de duplicar)
			const exists = prev.some((x) => x.input_id === input.input_id);
			if (!exists) return [...prev, input];
			return prev.map((x) => (x.input_id === input.input_id ? { ...x, ...input } : x));
		});

		setCaldaProd(null);
		setCaldaDose("");
		toast.success("Insumo adicionado/atualizado na Calda Avulsa.");
		// 🔥 foco de volta no input
		// 🔥 foco de volta no input (robusto p/ MUI)
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				caldaInputRef.current?.focus();
			});
		});
	};

	console.log('caldaAvulsa: ',)

	const handleRemoveFromCaldaAvulsa = (input_id) => {
		setCaldaAvulsa((prev) => prev.filter((x) => x.input_id !== input_id));
	};

	const handleClearCaldaAvulsa = async () => {
		if (!caldaAvulsa.length) return;

		const result = await Swal.fire({
			title: "Limpar Calda Avulsa?",
			html: "Isso vai remover todos os insumos da calda e desmarcar o uso nos cards desta fazenda.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim, limpar",
			cancelButtonText: "Cancelar",
			reverseButtons: true,
			focusCancel: true,

			// 👇 ESSENCIAL
			customClass: {
				container: "swal-high-zindex"
			},

			didOpen: () => {
				const container = document.querySelector(".swal-high-zindex");
				if (container) {
					container.style.zIndex = "2000";
				}
			}
		});

		if (!result.isConfirmed) return;

		if (!result.isConfirmed) return;

		setCaldaAvulsa([]);
		setUseCaldaAvulsaByApp({});

		try {
			setCaldaSyncing(true);
			await clearCaldaAvulsaFS(); // ✅ apaga o doc global
			toast.success("Calda Avulsa limpa (global).");
		} catch (e) {
			console.warn(e);
			toast.error("Falha ao limpar no Firebase.");
		} finally {
			setCaldaSyncing(false);
		}
	};



	const toggleUseCaldaAvulsa = (hiddenAppName) => {
		if (!caldaAvulsa.length) return;

		setUseCaldaAvulsaByApp((prev) => {
			const next = { ...prev, [hiddenAppName]: !prev[hiddenAppName] };
			return next;
		});

		// quando liga a calda avulsa, limpa ações manuais daquele card
		setProdsToRemove((prev) => prev.filter((x) => x.appName !== hiddenAppName));
		setprodsToAdd((prev) => prev.filter((x) => x.appName !== hiddenAppName));
	};



	const iconDict = [
		{ cultura: "Feijão", icon: beans, alt: "feijao" },
		{ cultura: "Arroz", icon: rice, alt: "arroz" },
		{ cultura: "Soja", icon: soy, alt: "soja" },
		{ cultura: "Algodão", icon: cotton, alt: "algodao" },
		{ cultura: "Milho", icon: corn, alt: "milho" }
	];


	const parcelasOcc = useMemo(() => {
		const map = new Map();

		objResumValues.forEach((dat) => {
			const fullStage = dat?.data?.estagio; // "2º Cobertura|Programa ..."
			if (!fullStage) return;

			const [estagioLabel, programaLabel] = fullStage.split("|");
			const hiddenAppName = fullStage + farmSelected;

			// Se o bloco (app) estiver escondido, ignore para não poluir o tooltip
			if (hidenAppsArr.includes(hiddenAppName)) return;

			const cron = dat?.data?.cronograma || [];

			cron.forEach((p) => {
				const parcela = p?.parcela;
				if (!parcela) return;

				// DAP desejado vem daqui
				const dapAppRaw = p?.dapApp;
				const dapApp = Number(dapAppRaw);
				const dapAppVal = Number.isFinite(dapApp) ? dapApp : null;

				if (!map.has(parcela)) {
					map.set(parcela, { count: 0, stages: new Map() });
				}

				const entry = map.get(parcela);
				entry.count += 1;

				// Um stage único por fullStage; se houver mais de um item no mesmo stage,
				// mantenha o menor dapApp (bom para ordenar)
				const prev = entry.stages.get(fullStage);

				if (!prev) {
					entry.stages.set(fullStage, {
						estagio: (estagioLabel || "").trim(),
						programa: (programaLabel || "").trim(),
						dapApp: dapAppVal, // <- agora existe no tooltip
					});
				} else {
					const prevDap = prev.dapApp;
					const nextMin =
						prevDap == null ? dapAppVal : dapAppVal == null ? prevDap : Math.min(prevDap, dapAppVal);

					entry.stages.set(fullStage, {
						...prev,
						dapApp: nextMin,
					});
				}
			});
		});

		const out = {};
		map.forEach((v, parcela) => {
			// Ordena pelo menor dapApp -> maior dapApp
			const stagesArr = Array.from(v.stages.values()).sort((a, b) => {
				const da = a.dapApp ?? 999999;
				const db = b.dapApp ?? 999999;
				return da - db;
			});

			out[parcela] = { count: v.count, stages: stagesArr };
		});

		return out;
	}, [objResumValues, farmSelected, hidenAppsArr]);


	const getStageName = (fullStage) => (fullStage?.split("|")?.[0] || "").trim();
	const norm = (s) => (s || "").trim().toLowerCase();


	useEffect(() => {
		if (!objList || objList.length === 0) return;

		const stageMap = new Map();

		objList.forEach((bloco) => {
			const cronograma = bloco?.cronograma || [];

			cronograma.forEach((item) => {
				const nomeVar = item.variedade?.trim();
				const nomeCult = item.cultura?.trim().toLowerCase();
				const nomeParcela = item.parcela?.trim();

				const atendeCultura =
					culturaSelecionada.length === 0 || culturaSelecionada.includes(nomeCult);

				const vObj = filterVariedade.find(
					(v) => v.nome === nomeVar && v.cultura === nomeCult
				);

				const atendeVariedade =
					variedadeSelecionada.length === 0 ||
					(vObj && variedadeSelecionada.includes(vObj.id));

				const atendeParcela =
					parcelasSelecionada.length === 0 ||
					parcelasSelecionada.includes(nomeParcela?.toLowerCase().replace(/\s+/g, "_"));

				if (!atendeCultura || !atendeVariedade || !atendeParcela) return;

				const stageLabel = getStageName(item.estagio);
				const stageId = norm(stageLabel);
				if (!stageId) return;

				if (!stageMap.has(stageId)) {
					stageMap.set(stageId, { id: stageId, label: stageLabel, count: 0 });
				}
				stageMap.get(stageId).count += 1;
			});
		});

		const opts = Array.from(stageMap.values()).sort((a, b) =>
			a.label.localeCompare(b.label)
		);

		setFilterEstagios(opts);
	}, [objList, culturaSelecionada, variedadeSelecionada, parcelasSelecionada, filterVariedade]);


	useEffect(() => {
		const getDefensivosData = async () => {
			setIsLoadingProdsToUse(true)
			try {
				await djangoApi
					.get("defensivo/get_defensivos_integration_farmbox/", {
						headers: {
							Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`
						}
					})
					.then((res) => {
						console.log(res);
						const { dados } = res.data
						setProdsToUse(dados)
						setIsLoadingProdsToUse(false)
					});
			} catch (err) {
				console.log("Erro ao alterar as aplicações", err);
			} finally {
				setIsLoadingProdsToUse(false)
			}
		};
		getDefensivosData()
	}, []);

	const selectedProd = useRef(null);
	const filterOptions = (options, { inputValue }) =>
		options
			.filter((o) =>
				o.name.toLowerCase().includes(inputValue.toLowerCase())
			)
			.slice(0, 100050);

	const handleAddProd = async (hiddenAppName, existProds, areaTotal) => {
		const prodRef = { current: null };
		const doseRef = { current: "" };
		const totalRef = { current: "" };

		const areaNum = Number(String(areaTotal ?? 0).replace(",", "."));

		const parseDecimalBR = (value) => {
			const raw = String(value ?? "").trim();
			if (!raw) return null;

			const normalized = raw.replace(/\./g, "").replace(",", ".");
			const num = Number(normalized);

			return Number.isFinite(num) ? num : null;
		};

		const formatBR3 = (value) => {
			const num = Number(value);
			if (!Number.isFinite(num)) return "";
			return num.toLocaleString("pt-BR", {
				minimumFractionDigits: 3,
				maximumFractionDigits: 3,
			});
		};

		const normalizeToApiDose = (value) => {
			const num = parseDecimalBR(value);
			if (!Number.isFinite(num)) return null;
			return num.toFixed(3);
		};

		const calcTotalFromDose = (doseValue) => {
			const doseNum = parseDecimalBR(doseValue);
			if (doseNum == null || !Number.isFinite(areaNum) || areaNum <= 0) return "";
			return formatBR3(doseNum * areaNum);
		};

		const calcDoseFromTotal = (totalValue) => {
			const totalNum = parseDecimalBR(totalValue);
			if (totalNum == null || !Number.isFinite(areaNum) || areaNum <= 0) return "";
			return formatBR3(totalNum / areaNum);
		};


		let root = null;

		const result = await MySwal.fire({
			title: "Adicionar insumo",
			html: `<div id="swal-react-root"></div>`,

			showConfirmButton: false,
			showCancelButton: false,
			showCloseButton: true,
			allowEscapeKey: true,
			allowOutsideClick: false,

			background:
				theme.palette.mode === "dark"
					? colors.blueOrigin[800]
					: "#ffffff",

			color:
				theme.palette.mode === "dark"
					? colors.primary[100]
					: "#000",

			customClass: {
				popup: "swal2-compact swal2-insumo-popup",
			},
			width: 980,

			didOpen: (popup) => {
				popup.style.overflow = "visible";
				popup.style.padding = "14px";
				popup.style.border = theme.palette.mode === "dark"
					? `1px solid ${colors.blueOrigin[600]}`
					: "1px solid #d7dbe2";
				popup.style.borderRadius = "16px";

				const container = popup.querySelector("#swal-react-root");
				if (!container) return;

				root = createRoot(container);

				// ✅ COMPONENTE DEFINIDO AQUI (corrige erro Form is not defined)
				const FormComponent = () => {
					const [doseValue, setDoseValue] = useState("");
					const [totalValue, setTotalValue] = useState("");

					const confirmAdd = () => {
						const prod = prodRef.current;
						const apiDose = normalizeToApiDose(doseRef.current);

						if (!prod) {
							MySwal.showValidationMessage("Selecione um produto.");
							return;
						}

						if (!doseRef.current || apiDose == null) {
							MySwal.showValidationMessage("Informe a dose ou o total.");
							return;
						}

						MySwal.close({
							isConfirmed: true,
							value: {
								prod,
								dose: apiDose,
							},
						});
					};

					return (
						<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
							<Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.88rem" }}>
								{hiddenAppName.replace("|", " - ").replace("Projeto", " - ")}
							</Typography>

							<Typography variant="caption" sx={{ opacity: 0.72, fontSize: "0.72rem" }}>
								Área considerada: {Number(areaNum || 0).toLocaleString("pt-BR", {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</Typography>

							<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
								<Autocomplete
									sx={{
										flexGrow: 1,
										minWidth: 380,
									}}
									options={prodsToUse || []}
									filterOptions={filterOptions}
									getOptionLabel={(opt) => opt?.name || opt?.produto || ""}
									isOptionEqualToValue={(a, b) =>
										(a?.id_farmbox ?? a?.input_id ?? a?.id) ===
										(b?.id_farmbox ?? b?.input_id ?? b?.id)
									}
									disablePortal
									componentsProps={{
										popper: {
											sx: {
												zIndex: 4000,
											},
										},
										paper: {
											sx: {
												backgroundColor:
													theme.palette.mode === "dark"
														? colors.blueOrigin[900]
														: "#ffffff",
												color:
													theme.palette.mode === "dark"
														? colors.primary[100]
														: "#000",
												borderRadius: 2,
												boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
												fontSize: "0.86rem",
												overflow: "hidden",
											},
										},
									}}
									ListboxProps={{
										sx: {
											padding: "4px",

											"& .MuiAutocomplete-option": {
												borderRadius: "8px",
												marginBottom: "2px",
												minHeight: "34px",
												cursor: "pointer",
												transition: "background-color 0.12s ease, color 0.12s ease",
											},

											// estado padrão
											"& .MuiAutocomplete-option:not(.Mui-focused):not(:hover):not([aria-selected='true'])": {
												backgroundColor: "transparent",
											},

											// hover com mouse
											"& .MuiAutocomplete-option:hover": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.18) !important"
														: "#d7dce2 !important",
											},

											// focus por teclado / setas
											"& .MuiAutocomplete-option.Mui-focused": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.22) !important"
														: "#d1d6dc !important",
											},

											// fallback para algumas versões do MUI
											"& .MuiAutocomplete-option[data-focus='true']": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.22) !important"
														: "#d1d6dc !important",
											},

											// item selecionado
											"& .MuiAutocomplete-option[aria-selected='true']": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.26) !important"
														: "#c8ced6 !important",
												fontWeight: 700,
											},

											// selecionado + hover
											"& .MuiAutocomplete-option[aria-selected='true']:hover": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.30) !important"
														: "#bcc3cc !important",
											},

											// selecionado + foco via teclado
											"& .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
												backgroundColor:
													theme.palette.mode === "dark"
														? "rgba(255,255,255,0.32) !important"
														: "#b8c0ca !important",
											},
										},
									}}
									onChange={(_, v) => {
										prodRef.current = v || null;
										requestAnimationFrame(() => {
											const doseInput =
												popup.querySelector('input[name="swal-dose-input"]');
											doseInput?.focus();
											doseInput?.select?.();
										});
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label="Insumo"
											autoFocus
											variant="outlined"
											size="small"
											sx={{
												"& .MuiInputBase-root": {
													backgroundColor:
														theme.palette.mode === "dark"
															? colors.blueOrigin[700]
															: "#f5f5f5",
													color:
														theme.palette.mode === "dark"
															? "#fff"
															: "#000",
													fontSize: "0.86rem",
													minHeight: "38px",
												},
												"& .MuiInputLabel-root": {
													color:
														theme.palette.mode === "dark"
															? "#fff"
															: "#000",
													fontSize: "0.84rem",
												},
												"& .MuiOutlinedInput-notchedOutline": {
													borderColor:
														theme.palette.mode === "dark"
															? colors.blueOrigin[600]
															: "#ccc",
												},
											}}
										/>
									)}
								/>

								<TextField
									size="small"
									label="Dose"
									name="swal-dose-input"
									placeholder="0,000"
									inputMode="decimal"
									variant="outlined"
									value={doseValue}
									onChange={(e) => {
										const raw = e.target.value;
										doseRef.current = raw;
										setDoseValue(raw);

										const totalCalc = calcTotalFromDose(raw);
										totalRef.current = totalCalc;
										setTotalValue(totalCalc);
									}}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											e.preventDefault();
											confirmAdd();
										}
									}}
									sx={{
										width: 160,
										"& .MuiInputBase-root": {
											backgroundColor:
												theme.palette.mode === "dark"
													? colors.blueOrigin[700]
													: "#f5f5f5",
											color:
												theme.palette.mode === "dark"
													? "#fff"
													: "#000",
											fontSize: "0.84rem",
											minHeight: "38px",
										},
										"& .MuiInputLabel-root": {
											color:
												theme.palette.mode === "dark"
													? "#fff"
													: "#000",
											fontSize: "0.82rem",
										},
										"& .MuiOutlinedInput-notchedOutline": {
											borderColor:
												theme.palette.mode === "dark"
													? colors.blueOrigin[600]
													: "#ccc",
										},
									}}
								/>

								<TextField
									size="small"
									label="Total"
									name="swal-total-input"
									placeholder="0,000"
									inputMode="decimal"
									variant="outlined"
									value={totalValue}
									onChange={(e) => {
										const raw = e.target.value;
										totalRef.current = raw;
										setTotalValue(raw);

										const doseCalc = calcDoseFromTotal(raw);
										doseRef.current = doseCalc;
										setDoseValue(doseCalc);
									}}
									onKeyDown={(e) => {
										if (e.key === "Enter") {
											e.preventDefault();
											confirmAdd();
										}
									}}
									sx={{
										width: 160,
										"& .MuiInputBase-root": {
											backgroundColor:
												theme.palette.mode === "dark"
													? colors.blueOrigin[700]
													: "#f5f5f5",
											color:
												theme.palette.mode === "dark"
													? "#fff"
													: "#000",
											fontSize: "0.84rem",
											minHeight: "38px",
										},
										"& .MuiInputLabel-root": {
											color:
												theme.palette.mode === "dark"
													? "#fff"
													: "#000",
											fontSize: "0.82rem",
										},
										"& .MuiOutlinedInput-notchedOutline": {
											borderColor:
												theme.palette.mode === "dark"
													? colors.blueOrigin[600]
													: "#ccc",
										},
									}}
								/>

								<Button
									variant="contained"
									size="small"
									onClick={confirmAdd}
									sx={{
										height: "38px",
										minWidth: 100,
										borderRadius: "10px",
										textTransform: "none",
										fontWeight: 700,
										fontSize: "0.78rem",
										px: 1.6,
										whiteSpace: "nowrap",
										backgroundColor:
											theme.palette.mode === "dark"
												? colors.blueAccent[500]
												: colors.blueAccent[600],
									}}
								>
									Adicionar
								</Button>
							</Box>

							<Typography variant="caption" sx={{ opacity: 0.68, fontSize: "0.72rem" }}>
								Altere dose ou total. O outro campo será recalculado automaticamente.
							</Typography>
						</Box>
					);
				};

				root.render(<FormComponent />);
			},

			willClose: () => {
				try {
					root?.unmount();
				} catch { }
				root = null;
			},
		});

		const value = result?.value;
		const confirmed =
			result?.isConfirmed ||
			(value && value.prod && typeof value.dose !== "undefined");

		if (!confirmed || !value) return;

		const { prod, dose } = value;
		const prodName = prod?.name || prod?.produto;

		const alreadyInCalda = (existProds || []).some(
			(p) => p?.produto === prodName
		);

		const scheduledToRemove = prodsToRemove
			.filter((item) => item.appName === hiddenAppName)
			.some(
				(item) => item.prodToRemove?.produto === prodName
			);

		if (alreadyInCalda && !scheduledToRemove) {
			await Swal.fire({
				title: "Atenção!!",
				html: "<b>Produto já consta na Calda</b>",
				icon: "warning",
			});
			return;
		}

		const newProd = {
			input_id: prod?.input_id ?? prod?.id_farmbox ?? prod?.id,
			dosage_unity: prod?.dosage_unity ?? prod?.formulacao ?? null,
			dosage_value: Number(dose),
		};

		const prodToAdd = {
			objToSendtoFarm: newProd,
			objToRender: {
				dose: Number(dose),
				produto: prodName,
			},
			appName: hiddenAppName,
		};

		setprodsToAdd((prev) => [...prev, prodToAdd]);

		toast.success("Produto Adicionado com sucesso!!", {
			position: "bottom-right",
			duration: 2000,
		});
	};


	const handleDeleteProdManual = (prod, hiddenAppName) => {
		setprodsToAdd((prev) =>
			prev.filter(
				(item) =>
					// mantém se NÃO for o app em questão...
					item.appName !== hiddenAppName ||
					// ...ou se for o app, mas NÃO é o mesmo produto
					item.objToRender?.produto !== prod.produto
			)
		);
	};

	const handleDeleteProd = (prod, prodsArray, appName) => {
		// console.log("AppName:", appName);

		const prodToRemove = prodsArray.find((data) => data.produto === prod.produto);
		// console.log("prodToRemove", prodToRemove);

		setProdsToRemove((prev) => {
			const alreadyExists = prev.some(
				(item) =>
					item.appName === appName &&
					item.prodToRemove?.produto === prodToRemove?.produto
			);

			if (alreadyExists) {
				// Remove o item se já existir
				return prev.filter(
					(item) =>
						!(item.appName === appName && item.prodToRemove?.produto === prodToRemove?.produto)
				);
			} else {
				// Adiciona o item
				return [...prev, { appName, prodToRemove }];
			}
		});
	};


	const handleSetApp = (dataId, estagio, hiddenAppName, plantioIdFarmbox) => {
		const newDict = {
			id: dataId,
			estagio: estagio,
			appName: hiddenAppName,
			plantioIdFarmbox
		};
		const isIn = updateApp.some(
			(data) => data.id === dataId && data.estagio === estagio
		);
		if (isIn) {
			// console.log("já colocado");
			const newArr = updateApp.filter((data) => {
				const newData = `${data.id}${data.estagio}`;
				const oldData = `${dataId}${estagio}`;
				return newData !== oldData;
			});
			setUpdateApp(newArr);
		} else {
			setUpdateApp((updateApp) => [...updateApp, newDict]);
			// console.log("ainda não estava");
		}
	};

	const handleSetAppMany = (dataId, estagio, hiddenAppName, plantioIdFarmbox) => {
		const newDict = {
			id: dataId,
			estagio: estagio,
			appName: hiddenAppName,
			plantioIdFarmbox
		};
		const isIn = updateApp.some(
			(data) => data.appName === hiddenAppName
		);
		if (isIn) {
			const newArr = updateApp.filter((data) => data.appName !== hiddenAppName)
			setUpdateApp(newArr);
		} else {
			setUpdateApp((updateApp) => [...updateApp, newDict]);
		}
	};

	// const handleRequestDjangoMaps = () => {
	// 	setLoadMaps(!loadMaps)
	// }

	const handleSendApiApp = async (data) => {
		const params = JSON.stringify({ data });
		try {
			setSendingData(true);

			const res = await djangoApi.put(
				"plantio/update_aplication_plantio/",
				params,
				{
					headers: {
						Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
					},
				}
			);

			const taskId = res.data.task_id;
			console.log("🔁 Task iniciada:", taskId);

			if (!taskId) {
				throw new Error("task_id não recebido!");
			}

			let attempts = 0;
			const maxAttempts = 60; // até 60 segundos
			const intervalId = setInterval(async () => {
				try {
					const statusRes = await djangoApi.get(
						`backgroundtask/${taskId}/task_status/`,
						{
							headers: {
								Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
							},
						}
					);

					const taskStatus = statusRes.data.status;
					console.log("🔍 Verificando status:", statusRes);
					console.log("🔍 Verificando status:", taskStatus);

					if (taskStatus === "done") {
						clearInterval(intervalId);
						setSendingData(false);

						Swal.fire({
							title: "Atualização concluída!",
							text: "As aplicações foram atualizadas com sucesso.",
							icon: "success",
							confirmButtonText: "Ok",
						});

						// setPositiveSignal(true);
						setPositiveSignal(false)
						handleRefreshData()
						// setTimeout(() => setPositiveSignal(false), 1500);
						// setTimeout(() => handleRefreshData(), 1700);
					}

					if (taskStatus === "failed") {
						clearInterval(intervalId);
						setSendingData(false);

						console.error("❌ Task falhou!", statusRes.data.result?.error);

						Swal.fire({
							title: "Erro ao processar!",
							text: "A tarefa falhou. Verifique os dados e tente novamente.",
							icon: "error",
							confirmButtonText: "Fechar",
						});
					}

					if (++attempts >= maxAttempts) {
						clearInterval(intervalId);
						setSendingData(false);
						Swal.fire({
							title: "Tempo esgotado",
							text: "A verificação da tarefa excedeu o tempo máximo.",
							icon: "warning",
						});
					}
				} catch (err) {
					console.error("Erro ao consultar status da task:", err);
					clearInterval(intervalId);
					setSendingData(false);
					Swal.fire({
						title: "Erro de rede",
						text: "Erro ao consultar o status da tarefa.",
						icon: "error",
					});
				}
			}, 1000);
		} catch (err) {
			console.error("Erro ao iniciar a tarefa:", err);
			setSendingData(false);
			Swal.fire({
				title: "Erro de envio",
				text: "Erro ao iniciar o envio das aplicações.",
				icon: "error",
			});
		}
	};

	// const handleSendApiApp = async (data) => {
	// 	const params = JSON.stringify({
	// 		data: data
	// 	});
	// 	try {
	// 		setSendingData(true);
	// 		await djangoApi
	// 			.put("plantio/update_aplication_plantio/", params, {
	// 				headers: {
	// 					Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`
	// 				}
	// 			})
	// 			.then((res) => {
	// 				console.log(res);
	// 			});
	// 	} catch (err) {
	// 		console.log("Erro ao alterar as aplicações", err);
	// 	} finally {
	// 		setUpdateApp([]);
	// 		setSendingData(false);

	// 		setPositiveSignal(true);
	// 		setTimeout(() => {
	// 			setPositiveSignal(false);
	// 		}, 1500);

	// 		setTimeout(() => {
	// 			handleRefreshData();
	// 		}, 1700);
	// 	}
	// };

	const handleShowMaps = () => {
		setShowMapps(!showMapps);
	};

	// const handlerShowMaps = useCallback(() => {
	// 	if (showMapps && farmSelected) {
	// 		setShowMapps(false);
	// 		setTimeout(() => {
	// 			setShowMapps(true);
	// 		}, 500);
	// 	}
	// }, [farmSelected, showMapps]);

	// useEffect(() => {
	// 	handlerShowMaps();
	// }, [farmSelected, handlerShowMaps]);

	const filteredIcon = (data) => {
		const filtered = iconDict.filter(
			(dictD) => dictD.cultura === data.cultura
		);

		if (filtered.length > 0) {
			return filtered[0].icon;
		}
		return "";
	};

	const filteredAlt = (data) => {
		const filtered = iconDict.filter(
			(dictD) => dictD.cultura === data.cultura
		);

		if (filtered.length > 0) {
			return filtered[0].alt;
		}
		return "";
	};

	useEffect(() => {
		(async () => {
			try {
				await djangoApi
					.post("plantio/get_plantio_detail_map/", safraCiclo, {
						headers: {
							Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`
						}
					})
					.then((res) => {
						setDataToMap(res.data.dados_plantio);
					})
					.catch((err) => console.log(err));
			} catch (err) {
				console.log("Erro ao consumir a API", err);
			} finally {
				setIsLoading(false);
			}
		})();
	}, []);

	useEffect(() => {
		if (dataToMap) {
			const mapArray = dataToMap.map((data, i) => {
				return {
					projeto: data.fazenda,
					parcela: data.parcela,
					map_centro_id: data.dados.projeto_map_centro_id,
					map_zoom: data.dados.projeto_map_zoom,
					cultura: data.dados.cultura,
					variedade: data.dados.variedade,
					variedadeColor: data.dados.variedade_color,
					variedadeColorLine: data.dados.variedade_color_line,
					map_geo_poins: data?.dados?.map_geo_points?.map((data) => ({
						lat: Number(data.latitude),
						lng: Number(data.longitude)
					})),
					map_geo_center_points: data?.dados?.map_geo_points_center
				};
			});

			setMapArray(
				mapArray.filter((data) => data.projeto === farmSelected)
			);
			setLoadMaps(false)
		}
	}, [dataToMap, farmSelected]);

	useEffect(() => {
		const listFarm = plantioRedux
			.filter((data) => data.dados.inicializado_plantio === true)
			.map((data, i) => {
				return data.fazenda;
			});
		setFarmList([...new Set(listFarm)].sort());
		handleFilterList([...new Set(listFarm)].sort()[0]);
	}, [plantioRedux]);

	const handleFilterList = (farmName) => {
		setFarmSelected(farmName);
		localStorage.setItem("farmSelected_darmboxData", farmName);
		const filtList = plantioRedux.filter(
			(data) =>
				data.fazenda === farmName &&
				(data.dados.inicializado_plantio === true)
		);
		setFilteredList(filtList);
		setCulturaSelecionada([])
		setVariedadeSelecionada([])
	};

	useEffect(() => {
		const savedFarm = localStorage.getItem("farmSelected_darmboxData");

		if (savedFarm) {
			setFarmSelected(savedFarm);

			const filtList = plantioRedux.filter(
				(data) =>
					data.fazenda === savedFarm &&
					data.dados.inicializado_plantio === true
			);

			setFilteredList(filtList);
		}
	}, [plantioRedux]);

	const handleFilterTable = () => {
		setFiltData(!filtData);
	};

	const addDaysToDate = (dateStr, daysToAdd) => {
		// Convert the date string to a Date object
		const date = new Date(dateStr);

		// Add the specified number of days
		date.setDate(date.getDate() + daysToAdd);

		// Format the new date back to "yyyy-mm-dd"
		const newDateStr = date.toISOString().split('T')[0];

		return newDateStr;
	}

	useEffect(() => {
		const filtParcelas = filteredList.map((data, i) => {
			const initialDate = initialDateForm;
			const finalDate = finalDateForm ? finalDateForm : "2023-05-29";
			const cronograma = data.dados.cronograma;

			// PLOT MAT INFORMATION
			const projetoMapCentroId = data.dados.projeto_map_centro_id;
			const mapGeoPoints = data.dados.map_geo_points;
			const variedadeColor = data.dados.variedade_color;
			const variedadeColorLine = data.dados.variedade_color_line;
			const plantioId = data.dados.plantio_id;

			//INTEGRACAO FARMBOX
			const id_marcelo_pata = 15153
			const harvest_id = data.dados.safra_id_farmbox
			const farm_id = data.dados.projeto_id_farmbox
			const responsible_id = data.dados?.responsavel_id_farmbox ? data.dados?.responsavel_id_farmbox : id_marcelo_pata
			const charge_id = data.dados?.encarregado_id_farmbox ? data.dados?.encarregado_id_farmbox : id_marcelo_pata
			const today = (new Date()).toLocaleDateString('pt-BR').split('/').reverse().join('-')
			const endDate = addDaysToDate(today, 6)

			const plantations = []
			const inputs = []

			const objSendToFarm = {
				date: today,
				end_date: endDate,
				harvest_id,
				farm_id,
				responsible_id,
				charge_id,
				plantations,
				inputs,
				observations: 'Aplicação Aberta via integração'
			}

			// console.log('objToFarm', objSendToFarm)


			const cronArr = cronograma.map((cron, i) => {
				const aplicado = cron.aplicado;
				let cronOb;
				const dataPrev = cron["data prevista"];
				if (dataPrev >= initialDate && dataPrev <= finalDate) {
					const plantioIdFarmbox = data?.plantio_id_farmbox
					const estagio = cron.estagio;
					const dataPrevApp = dataPrev;
					const dapApp = cron.dap;
					const parcela = data.parcela;
					const variedade = data.dados.variedade;
					const dataPlantio = data.dados.data_inicio_plantio;
					const area = data.dados.area_colheita;
					const dap = data.dados.dap;
					const cultura = data.dados.cultura;
					const produtosAp = cron.produtos;
					const produtos = produtosAp.map((data) => ({
						...data,
						area: area
					}));
					cronOb = {
						parcela,
						variedade,
						dataPlantio,
						estagio,
						dataPrevApp,
						dapApp,
						area,
						dap,
						cultura,
						produtos,
						aplicado,
						projetoMapCentroId,
						mapGeoPoints,
						variedadeColor,
						variedadeColorLine,
						plantioId,
						objSendToFarm,
						plantioIdFarmbox
					};
				}
				return cronOb;
			});
			if (!onlyOpenApp) {
				return cronArr.filter(
					(data) => data !== undefined && data.aplicado === false
				);
			} else {
				return cronArr.filter((data) => data !== undefined);
			}
		});
		const compare = (a, b) => {
			// if(new Date(a.dataPrevApp) < new Date(b.dataPrevApp)) return -1;
			// if(new Date(a.dataPrevApp) > new Date(b.dataPrevApp)) return 1;
			if (a.dapApp < b.dapApp) return -1;
			if (a.dapApp > b.dapApp) return 1;
			// if(a.cultura < b.cultura) return -1;
			// if(a.cultura > b.cultura) return 1;

			// if(a.variedade < b.variedade) return -1;
			// if(a.variedade > b.variedade) return 1;

		}
		const filtArray = filtParcelas
			.flat()
			.sort(compare)
			.sort((a, b) => a.estagio.split('|')[1]?.localeCompare(b.estagio.split('|')[1]))
		// .sort((a, b) => a.cultura.localeCompare(b.cultura))
		// .sort((a, b) => new Date(a.dataPrevApp) - new Date(b.dataPrevApp) || )
		// .sort((a, b) => a.dapApp - b.dapApp)
		const result = filtArray.reduce((acc, curr) => {
			const estagio = curr.estagio;
			const dapApp = curr.dapApp;
			if (dapApp >= 0) {
				if (acc[estagio] == null) acc[estagio] = [];
				acc[estagio].push(curr);
			}
			return acc;
		}, {});
		const dictTotal = [];
		Object.keys(result).map((data, i) => {
			// console.log('data', data)
			// console.log('resultData', result[data])

			//Array to send plantations to FarmBox
			const plantationsFarm = []

			const total = result[data].reduce((acc, curr) => {
				const objToAdd = {
					sought_area: curr.area,
					plantation_id: curr.plantioIdFarmbox
				}
				plantationsFarm.push(objToAdd)
				return curr.area + acc;
			}, 0);

			//Array to send plantations to FarmBox
			const inputsFarm = []
			let objToFarm;
			const produtosArr = result[data].map((data, i) => {
				if (i === 0) {
					objToFarm = data.objSendToFarm
				}
				const filtArr = data.produtos
					.sort((a, b) => a.tipo.localeCompare(b.tipo))
					.map((data) => {
						if (inputsFarm.filter((insumosInside) => insumosInside.input_id === data.id_farmbox).length === 0) {
							const objToAdd = {
								dosage_value: parseFloat(data.dose),
								dosage_unity: data.formulacao,
								input_id: data.id_farmbox
							}
							inputsFarm.push(objToAdd)
						}
						return data;
					});
				return filtArr;
			});
			const firstOrder = inputsFarm.filter((input) => input.dosage_unity === 'un_ha')
			const secondOrder = inputsFarm.filter((input) => input.dosage_unity !== 'un_ha')
			let inputsOrdered = []
			if (showProducts) {
				inputsOrdered = [...firstOrder, ...secondOrder]
			} else {
				inputsOrdered = firstOrder
			}
			//obj para enviar ao farm
			const dataToFarmBox = {
				...objToFarm,
				plantations: plantationsFarm,
				inputs: inputsOrdered,
			}

			const newDic = {
				estagio: data,
				cronograma: result[data],
				total: total.toLocaleString("pt-br", {
					maximumFractionDigits: 2
				}),
				produtos: produtosArr.flat(),
				dataToFarmBox: dataToFarmBox
			};
			dictTotal.push(newDic);
			return newDic;
		});
		setObjList(dictTotal);
	}, [filteredList, initialDateForm, finalDateForm, onlyOpenApp, showProducts]);

	function gerarCulturasEVariedadesParaSelect(objList) {
		const culturaMap = new Map();
		const variedadeSet = new Set();
		const parcelasSet = new Set();

		const variedades = [];
		const parcelas = [];

		objList.forEach((item) => {
			const cronograma = item.cronograma || [];

			cronograma.forEach((p) => {
				const cultura = p.cultura?.trim();
				const variedade = p.variedade?.trim();
				const parcela = p.parcela?.trim(); // ← supondo que o nome do campo seja esse

				if (cultura && !culturaMap.has(cultura)) {
					culturaMap.set(cultura, {
						id: cultura.toLowerCase(),
						nome: cultura,
					});
				}

				const key = `${cultura}|${variedade}`;
				if (cultura && variedade && !variedadeSet.has(key)) {
					variedadeSet.add(key);
					variedades.push({
						id: variedades.length + 1,
						nome: variedade,
						cultura: cultura.toLowerCase(),
					});
				}

				const keyParcela = `${parcela}|${cultura}|${variedade}`;
				if (parcela && !parcelasSet.has(keyParcela)) {
					parcelasSet.add(keyParcela);
					parcelas.push({
						id: parcela.toLowerCase().replace(/\s+/g, "_"),
						nome: parcela,
						cultura: cultura?.toLowerCase() || null,
						variedade: variedade || null,
					});
				}
			});
		});

		return {
			culturas: Array.from(culturaMap.values()),
			variedades,
			parcelas,
		};
	}

	useEffect(() => {
		const useArr = [...objList];

		const filtArr = useArr
			.map((data) => {
				const cronograma = data?.cronograma || [];

				// Filtra apenas as parcelas que atendem aos critérios
				const parcelasFiltradas = cronograma.filter((item) => {
					const nomeVar = item.variedade?.trim();
					const nomeCult = item.cultura?.trim().toLowerCase();
					const nomeParcela = item.parcela?.trim();

					const atendeCultura =
						culturaSelecionada.length === 0 ||
						culturaSelecionada.includes(nomeCult);

					const vObj = filterVariedade.find(
						(v) => v.nome === nomeVar && v.cultura === nomeCult
					);

					const atendeVariedade =
						variedadeSelecionada.length === 0 ||
						(vObj && variedadeSelecionada.includes(vObj.id));

					const atendeParcela =
						parcelasSelecionada.length === 0 ||
						parcelasSelecionada.includes(
							nomeParcela?.toLowerCase().replace(/\s+/g, "_")
						);

					const stageKey = norm(getStageName(item.estagio));

					const atendeEstagio =
						estagiosSelecionados.length === 0 || estagiosSelecionados.includes(stageKey);

					return atendeCultura && atendeVariedade && atendeParcela && atendeEstagio;
				});

				// Se nenhuma parcela passou no filtro, descarta o bloco
				if (parcelasFiltradas.length === 0) return null;

				// Gerar totais com base nas parcelas filtradas
				const produtosFiltrados = parcelasFiltradas.flatMap((p) => p.produtos);
				let result = [];

				produtosFiltrados.reduce((res, value) => {
					if (!res[value.produto]) {
						res[value.produto] = {
							produto: value.produto,
							qty: 0,
							dose: Number(value.dose),
							tipo: value.tipo,
						};
						result.push(res[value.produto]);
					}
					res[value.produto].qty += value.area * Number(value.dose);
					return res;
				}, {});

				// Calcula total de área das parcelas filtradas
				const totalArea = parcelasFiltradas.reduce(
					(acc, p) => acc + Number(p.area),
					0
				);
				// console.log('checkHere: ', data.dataToFarmBox)
				// console.log('parcelasFiltadas: ', parcelasFiltradas.map((data) => data.plantioIdFarmbox))
				const onlyFiltersFarmsIds = parcelasFiltradas.map((data) => data.plantioIdFarmbox)
				return {
					data: {
						...data,
						dataToFarmBox: {
							...data.dataToFarmBox,
							plantations: data.dataToFarmBox.plantations.filter((dataInside) => onlyFiltersFarmsIds.includes(dataInside.plantation_id))
						},
						cronograma: parcelasFiltradas,
						total: totalArea.toFixed(2).replace('.', ','), // mantém compatibilidade
					},
					totais: result,
				};
			})
			.filter(Boolean); // remove os blocos nulos

		// Área total geral
		const totalArea = filtArr.map((data) =>
			Number(data.data.total.replace('.', '').replace(',', '.'))
		);
		const sum = totalArea.reduce((acc, val) => acc + val, 0);

		setAreaFiltTotal(sum);
		setObjResumValues(filtArr);

		// Parcelas filtradas
		const parcelasArr = filtArr.flatMap((data) =>
			data.data.cronograma.map((p) => p.parcela)
		);
		setfilteredAndDucplicatedParcelas(parcelasArr);
	}, [objList, culturaSelecionada, variedadeSelecionada, filterVariedade, parcelasSelecionada, estagiosSelecionados]);


	useEffect(() => {
		if (!objList || objList.length === 0) return;

		const { culturas, variedades, parcelas } = gerarCulturasEVariedadesParaSelect(objList);
		setFilterCultura(culturas);
		setFilterVariedade(variedades);
		setFilterParcela(parcelas); // 👈 agora também atualiza parcelas

	}, [objList]);

	// useEffect(() => {
	// 	const useArr = [...objList];
	// 	const filtArr = useArr.map((data, i) => {
	// 		const dataProdutos = data.produtos;
	// 		var result = [];
	// 		// const area_total = data.total.replace(".", "").replace(",", ".");
	// 		// console.log(parseFloat(area_total));
	// 		dataProdutos.reduce(function (res, value) {
	// 			if (!res[value.produto]) {
	// 				res[value.produto] = {
	// 					produto: value.produto,
	// 					qty: 0,
	// 					dose: Number(value.dose),
	// 					tipo: value.tipo
	// 				};
	// 				result.push(res[value.produto]);
	// 			}
	// 			res[value.produto].qty += value.area * Number(value.dose);
	// 			return res;
	// 		}, {});
	// 		return { data, totais: result };
	// 	});
	// 	const totalArea = filtArr.map((data) =>
	// 		Number(data.data.total.replace(".", "").replace(",", "."))
	// 	);
	// 	var sum = totalArea.reduce((accumulator, currentValue) => {
	// 		return accumulator + currentValue;
	// 	}, 0);
	// 	setAreaFiltTotal(sum);
	// 	setObjResumValues(filtArr);
	// 	console.log('filtArr: ', filtArr)
	// 	const { culturas, variedades } = gerarCulturasEVariedadesParaSelect(filtArr);
	// 	setFilterCultura(culturas)
	// 	setFilterVariedade(variedades)
	// 	const parcelasArr = filtArr.map((data) => {
	// 		const parcelasHere = data.data.cronograma.map((parcela) => parcela.parcela)
	// 		return parcelasHere.flat()
	// 	})
	// 	setfilteredAndDucplicatedParcelas(parcelasArr.flat())

	// }, [objList]);

	const formatName = () => {
		const saveFile = farmSelected;
		return saveFile;
	};

	const hasduplicated = (parcela) => (parcelasOcc?.[parcela]?.count || 0) > 1;


	const generatePDF = async () => {
		try {
			setIsGeneratingPDF(true);

			// Esconde elementos com classe .print-safe-wrapper (ex: botões)
			document.querySelectorAll(".print-safe-wrapper").forEach(el => {
				el.style.visibility = "hidden";
			});

			const actualTheme = theme.palette.mode;
			if (actualTheme === 'dark') {
				colorMode.toggleColorMode();
			}

			// Pequena pausa para aplicar mudanças visuais
			await new Promise(res => setTimeout(res, 300));

			const pdf = new jsPDF("portrait", "pt", "a4");
			const pageHeight = pdf.internal.pageSize.getHeight() - 40; // margem de 20pt topo/baixo
			const pageWidth = pdf.internal.pageSize.getWidth() - 40;   // margem lateral

			const headerDiv = document.querySelector(".print-fazenda-div");
			// const contentDivs = Array.from(document.querySelectorAll(".mainProgramAllDiv"));
			const contentDivs = Array.from(document.querySelectorAll(".mainProgramAllDiv"))
				.filter(div => {
					const appName = div.getAttribute("data-appname");
					return !hidenAppsArr.includes(appName);  // só inclui os visíveis
				});
			const footerDiv = document.querySelector("#footerDiv");

			// Junta todos os elementos para renderizar no PDF
			const allDivs = [headerDiv, ...contentDivs];
			if (footerDiv) allDivs.push(footerDiv);

			let currentY = 20;

			for (let i = 0; i < allDivs.length; i++) {
				const div = allDivs[i];
				if (!div) continue;
				if (i > 0) {
					div.style.display = 'block';
				}
				div.style.opacity = '1';
				div.style.visibility = 'visible';

				const canvas = await html2canvas(div, {
					scale: 1.2,
					useCORS: true,
					allowTaint: true,
				});

				const imgData = canvas.toDataURL("image/jpeg", 0.7);
				const imgProps = pdf.getImageProperties(imgData);

				const imgWidth = pageWidth;
				const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

				if (currentY + imgHeight > pageHeight) {
					pdf.addPage();
					currentY = 20;
				}

				pdf.addImage(imgData, "JPEG", 20, currentY, imgWidth, imgHeight);
				currentY += imgHeight + 10;
			}

			pdf.save(`${formatName()}.pdf`);

			if (actualTheme === 'dark') {
				colorMode.toggleColorMode();
			}
		} catch (error) {
			console.error("Erro ao gerar PDF:", error);
		} finally {
			// Restaura visibilidade dos botões
			document.querySelectorAll(".print-safe-wrapper").forEach(el => {
				el.style.visibility = "visible";
			});
			setIsGeneratingPDF(false);
		}
	};

	const hiddenApps = (appNameToHdie, totalArea, parcelas) => {
		const parcelasToHide = parcelas.cronograma.map((parcelas) => parcelas.parcela)
		const formatArea = parseFloat(
			totalArea.replace(".", "").replace(",", ".")
		);
		if (hidenAppsArr.includes(appNameToHdie)) {
			const excludeApp = hidenAppsArr.filter(
				(data) => data !== appNameToHdie
			);
			setHidenAppsArr(excludeApp);
			const newArea = parseFloat(areaFiltTotal) + formatArea;
			setAreaFiltTotal(newArea);
			const reinsertParcelas = [...filteredAndDucplicatedParcelas, ...parcelasToHide]

			console.log('colocando')
			setfilteredAndDucplicatedParcelas(reinsertParcelas);
		} else {
			setHidenAppsArr((prev) => [...prev, appNameToHdie]);
			const newArea = parseFloat(areaFiltTotal) - formatArea;
			setAreaFiltTotal(newArea);

			console.log('retirando')
			setfilteredAndDucplicatedParcelas(prev => {
				parcelasToHide.forEach(item => {
					const index = prev.indexOf(item);
					if (index > -1) {
						prev.splice(index, 1);
					}
				})
				return prev
			})
		}
	};

	useEffect(() => {
		setHidenAppsArr([]);
	}, [farmSelected]);

	useEffect(() => {
		let alive = true;

		(async () => {
			try {
				const saved = await fetchCaldaAvulsa();

				if (!alive) return;

				if (!saved) {
					setCaldaAvulsa([]);
					setUseCaldaAvulsaByApp({});
				} else {
					const items = Array.isArray(saved.caldaAvulsa) ? saved.caldaAvulsa : [];
					const nextCalda = items.map(sanitizeCaldaItem).filter(Boolean);

					setCaldaAvulsa(nextCalda);

					// 🔥 IMPORTANTE:
					// você pediu que a calda sirva para todas as fazendas.
					// O "use por app" depende de hiddenAppName que inclui fazenda.
					// Então NÃO faz sentido persistir isso globalmente.
					// Mantém apenas em memória:
					setUseCaldaAvulsaByApp({});
				}
			} catch (e) {
				console.warn("Falha ao carregar Calda Avulsa do Firestore:", e);
				// fallback seguro
				setCaldaAvulsa([]);
				setUseCaldaAvulsaByApp({});
			} finally {
				if (!alive) return;
				setCaldaLoaded(true);
				skipFirstSaveRef.current = false;
			}
		})();

		return () => {
			alive = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!caldaLoaded) return;
		if (skipFirstSaveRef.current) return;

		// Se a calda estiver vazia, você pode optar por não salvar nada.
		// Eu recomendo: se vazia -> apaga o doc (limpa "collection").
		const t = setTimeout(async () => {
			try {
				setCaldaSyncing(true);

				if (!caldaAvulsa.length) {
					await clearCaldaAvulsaFS();
				} else {
					await saveCaldaAvulsa({ caldaAvulsa });
				}
			} catch (e) {
				console.warn("Falha ao salvar Calda Avulsa no Firestore:", e);
			} finally {
				setCaldaSyncing(false);
			}
		}, 350);

		return () => clearTimeout(t);
	}, [caldaAvulsa, caldaLoaded]);


	useEffect(() => {
		console.log('isThereAnyProdToAdd', prodsToAdd)
	}, [prodsToAdd]);

	// const handleOpenAppOld = async (data, cronograma, estagio, programaLoading, hiddenAppName) => {
	// 	console.log('data to send to Farmbox', data)
	// 	let newData = data
	// 	const isThereAnyProdToRemove = prodsToRemove.filter((data) => data.appName === hiddenAppName)
	// 	if (isThereAnyProdToRemove?.length > 0) {
	// 		console.log('yes, need to remove someProds here:');

	// 		// helper para padronizar a dose com 3 casas
	// 		const to3 = v => Number(v).toFixed(3);

	// 		// monta array de {id, dose} padronizados
	// 		const onlyIdToRemove = isThereAnyProdToRemove.map(data => ({
	// 			id: data.prodToRemove.id_farmbox,
	// 			dose: to3(data.prodToRemove.dose),
	// 		}));


	// 		// cria Set com chaves "id|dose" para busca eficiente
	// 		const removeKeys = new Set(
	// 			onlyIdToRemove.map(item => `${item.id}|${item.dose}`)
	// 		);

	// 		// filtra mantendo só os que NÃO estão no removeKeys
	// 		newData = {
	// 			...newData,
	// 			inputs: newData.inputs.filter(
	// 				prods => !removeKeys.has(`${prods.input_id}|${to3(prods.dosage_value)}`)
	// 			),
	// 		};
	// 	}
	// 	const isThereAnyProdToAdd = prodsToAdd.filter((data) => data.appName === hiddenAppName)
	// 	if (isThereAnyProdToAdd.length > 0) {
	// 		const onlyObjTOFarm = isThereAnyProdToAdd.map((data) => data.objToSendtoFarm)
	// 		newData = {
	// 			...newData,
	// 			inputs: [...newData.inputs, ...onlyObjTOFarm]
	// 		}
	// 	}

	// 	const isThereAnyPlantationToRemove = updateApp.filter((data) => data.appName === hiddenAppName)
	// 	let parcelasToUp = cronograma.map((crono) => ({ id: crono.plantioId, estagio: estagio }))
	// 	if (isThereAnyPlantationToRemove.length > 0) {
	// 		console.log('precisa remover as plantacoes abaixo:')
	// 		const onlyIdPlantations = isThereAnyPlantationToRemove.map((parcela) => parcela.plantioIdFarmbox)
	// 		newData = {
	// 			...newData,
	// 			plantations: newData.plantations.filter((data) => !onlyIdPlantations.includes(data.plantation_id))
	// 		}
	// 		const onlyPlantioId = isThereAnyPlantationToRemove.map((data) => data.id)

	// 		parcelasToUp = parcelasToUp.filter((data) => !onlyPlantioId.includes(data.id))
	// 	}

	// 	// console.log('newData', newData)
	// 	// console.log('parcelasToRemove', updateApp)
	// 	// console.log('cronograma', cronograma)
	// 	// console.log('parcelasToUp', parcelasToUp)

	// 	const params = JSON.stringify({
	// 		data: newData
	// 	});
	// 	try {
	// 		setAppIsLoading(programaLoading)
	// 		await djangoApi
	// 			.put("plantio/open_app_farmbox/", params, {
	// 				headers: {
	// 					Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`
	// 				}
	// 			})
	// 			.then((res) => {
	// 				console.log(res);
	// 				if (res.data.status === 201) {
	// 					const dataFromServer = JSON.parse(res.data.result)
	// 					const { code } = dataFromServer;
	// 					Swal.fire({
	// 						title: "Feito!!",
	// 						html: `AP Aberta com Sucesso: <b>${code}</b> `,
	// 						icon: "success"
	// 					});
	// 					parcelasToUp.forEach((parcela) => {
	// 						handleSetApp(parcela.id, parcela.estagio)
	// 					})
	// 				}
	// 				setAppIsLoading(null)
	// 			});
	// 	} catch (err) {
	// 		console.log("Erro ao alterar as aplicações", err);
	// 		console.log("Erro ao alterar as aplicações", err.response.data.msg);
	// 		console.log("Erro ao alterar as aplicações", JSON.parse(err.response.data.result));
	// 		toast.error(
	// 			`Erro ao Abrir a Aplicação - ${err.response.data.msg} - ${JSON.parse(err.response.data.result)}`,
	// 			{
	// 				position: "top-center",
	// 				duration: 5000
	// 			}
	// 		)
	// 		setAppIsLoading(null)
	// 	} finally {
	// 		console.log('finally alterar')
	// 	}
	// }
	const handleOpenApp = async (
		data,
		cronograma,
		estagio,
		programaLoading,
		hiddenAppName
	) => {
		const openedKey = hiddenAppName;

		// Bloqueia somente esta AP:
		// - se ela já estiver abrindo;
		// - ou se já tiver sido aberta.
		if (
			isAppLoading(openedKey) ||
			appsOpened.includes(openedKey)
		) {
			return;
		}

		console.log("data to send to Farmbox", data);

		let newData = data;

		const to3 = (v) => Number(v ?? 0).toFixed(3);

		const shouldUseAvulsa =
			!!useCaldaAvulsaByApp?.[hiddenAppName];

		if (shouldUseAvulsa) {
			if (!caldaAvulsa || caldaAvulsa.length === 0) {
				toast.error(
					"Monte a Calda Avulsa antes de usar.",
					{
						position: "top-left",
						duration: 4000,
					}
				);

				return;
			}

			const originalInputs = Array.isArray(newData.inputs)
				? newData.inputs
				: [];

			const operacaoInputs = originalInputs.filter(
				(x) =>
					String(
						x?.dosage_unity || ""
					).toLowerCase() === "un_ha"
			);

			const avulsaInputs = caldaAvulsa.map(
				({
					input_id,
					dosage_unity,
					dosage_value,
				}) => ({
					input_id,
					dosage_unity,
					dosage_value: Number(
						to3(dosage_value)
					),
				})
			);

			const operacaoIds = new Set(
				operacaoInputs.map((x) => x.input_id)
			);

			const avulsaSemDuplicarOperacao =
				avulsaInputs.filter(
					(x) => !operacaoIds.has(x.input_id)
				);

			newData = {
				...newData,
				inputs: [
					...operacaoInputs,
					...avulsaSemDuplicarOperacao,
				],
			};
		} else {
			const isThereAnyProdToRemove =
				prodsToRemove.filter(
					(x) =>
						x.appName === hiddenAppName
				);

			if (isThereAnyProdToRemove.length > 0) {
				const onlyIdToRemove =
					isThereAnyProdToRemove.map((x) => ({
						id: x.prodToRemove.id_farmbox,
						dose: to3(
							x.prodToRemove.dose
						),
					}));

				const removeKeys = new Set(
					onlyIdToRemove.map(
						(item) =>
							`${item.id}|${item.dose}`
					)
				);

				newData = {
					...newData,
					inputs: (
						newData.inputs || []
					).filter(
						(prod) =>
							!removeKeys.has(
								`${prod.input_id}|${to3(
									prod.dosage_value
								)}`
							)
					),
				};
			}

			const isThereAnyProdToAdd =
				prodsToAdd.filter(
					(x) =>
						x.appName === hiddenAppName
				);

			if (isThereAnyProdToAdd.length > 0) {
				const onlyObjToFarm =
					isThereAnyProdToAdd.map(
						(x) => x.objToSendtoFarm
					);

				newData = {
					...newData,
					inputs: [
						...(newData.inputs || []),
						...onlyObjToFarm,
					],
				};
			}
		}

		const isThereAnyPlantationToRemove =
			updateApp.filter(
				(x) => x.appName === hiddenAppName
			);

		let parcelasToUp = (cronograma || []).map(
			(crono) => ({
				id: crono.plantioId,
				estagio,
			})
		);

		if (isThereAnyPlantationToRemove.length > 0) {
			const onlyIdPlantations =
				isThereAnyPlantationToRemove.map(
					(parcela) =>
						parcela.plantioIdFarmbox
				);

			newData = {
				...newData,
				plantations: (
					newData.plantations || []
				).filter(
					(plantation) =>
						!onlyIdPlantations.includes(
							plantation.plantation_id
						)
				),
			};

			const onlyPlantioId =
				isThereAnyPlantationToRemove.map(
					(parcela) => parcela.id
				);

			parcelasToUp = parcelasToUp.filter(
				(parcela) =>
					!onlyPlantioId.includes(
						parcela.id
					)
			);
		}

		const params = JSON.stringify({
			data: newData,
		});

		try {
			// Marca somente esta AP como carregando.
			startAppLoading(openedKey);

			const res = await djangoApi.put(
				"plantio/open_app_farmbox/",
				params,
				{
					headers: {
						Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
					},
				}
			);

			if (
				res.data.status === 200 ||
				res.data.status === 201
			) {
				let dataFromServer = res.data.result;

				if (typeof dataFromServer === "string") {
					dataFromServer =
						JSON.parse(dataFromServer);
				}

				const code =
					dataFromServer?.code || "Sem número";

				toast.success(
					`AP ${code} aberta com sucesso.`,
					{
						position: "top-left",
						duration: 4000,
						id: `open-app-success-${openedKey}`,
					}
				);

				parcelasToUp.forEach((parcela) => {
					handleSetApp(
						parcela.id,
						parcela.estagio
					);
				});

				setAppsOpened((prev) =>
					prev.includes(openedKey)
						? prev
						: [...prev, openedKey]
				);
			}
		} catch (err) {
			console.error(
				"Erro ao abrir aplicação:",
				err
			);

			let apiResult =
				err.response?.data?.result || "";

			if (typeof apiResult === "string") {
				try {
					apiResult = JSON.parse(apiResult);
				} catch {
					// Mantém a mensagem original.
				}
			}

			const resultMessage =
				typeof apiResult === "object"
					? JSON.stringify(apiResult)
					: apiResult;

			toast.error(
				`Erro ao abrir a aplicação${err.response?.data?.msg
					? `: ${err.response.data.msg}`
					: ""
				}${resultMessage
					? ` — ${resultMessage}`
					: ""
				}`,
				{
					position: "top-left",
					duration: 5000,
					id: `open-app-error-${openedKey}`,
				}
			);
		} finally {
			// Libera somente esta AP.
			finishAppLoading(openedKey);
		}
	};


	return (
		<Box
			className={classes.mainDiv}
			style={{ backgroundColor: colors.blueOrigin[700] }}
			mt={3}
		>
			<Box
				className={`${classes.div} ${classes["farm-list-div"]}`}
				style={{ backgroundColor: colors.blueOrigin[800] }}
			>
				{farmList.map((data, i) => {
					return (
						<Box
							key={i}
							gap={10}
							sx={{
								boxShadow: "rgba(0, 0, 0, 0.65) 0px 5px 15px",
								borderRadius: "8px"
							}}
						>
							<Typography
								className={classes.hasitemInsideArr}
								style={{
									backgroundColor:
										farmSelected === data
											? colors.primary[900]
											: colors.brown[550],
									color:
										farmSelected === data &&
											theme.palette.mode === "light"
											? "black"
											: farmSelected !== data &&
												theme.palette.mode === "light"
												? "white"
												: colors.primary[100],
									fontStyle: "italic",
									fontWeight: 600
								}}
								variant="h6"
								onClick={() => handleFilterList(data)}
							>
								{data.replace("Projeto ", "")}
							</Typography>
						</Box>
					);
				})}
				<Box sx={{ marginLeft: "auto" }}>
					{isGeneratingPDF ? (
						<CircularProgress
							size={24}
							sx={{
								color: colors.blueAccent[500],
								marginRight: "12px",
							}}
						/>
					) : (
						<IconButton onClick={generatePDF}>
							<FontAwesomeIcon
								icon={faPrint}
								color={colors.blueAccent[500]}
								size={"sm"}
							/>
						</IconButton>
					)}
				</Box>
			</Box>
			<SelectCulturaVariedade
				culturaSelecionada={culturaSelecionada}
				setCulturaSelecionada={setCulturaSelecionada}
				variedadeSelecionada={variedadeSelecionada}
				setVariedadeSelecionada={setVariedadeSelecionada}
				culturas={filterCultura}
				variedades={filterVariedade}
				parcelas={filterParcela}
				parcelaSelecionada={parcelasSelecionada}
				setParcelaSelecionada={setParcelasSelecionada}

				estagios={filterEstagios}
				estagioSelecionado={estagiosSelecionados}
				setEstagioSelecionado={setEstagiosSelecionados}

				openMontarCalda={openMontarCalda}
				caldaAvulsa={caldaAvulsa}
				handleClearCaldaAvulsa={handleClearCaldaAvulsa}
			/>
			{/* <div className="print-safe-wrapper" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
				<Button
					variant="contained"
					color="secondary"
					size="small"
					onClick={openMontarCalda}
					startIcon={<PlaylistAddRoundedIcon />}
					sx={{ textTransform: "none", fontWeight: 800 }}
				>
					Montar Calda Avulsa
				</Button>

				<Chip
					size="small"
					color={caldaAvulsa.length ? "success" : "default"}
					label={`Itens: ${caldaAvulsa.length}`}
					sx={{ fontWeight: 800 }}
				/>

				<IconButton
					size="small"
					onClick={handleClearCaldaAvulsa}
					disabled={!caldaAvulsa.length}
					title="Limpar Calda Avulsa"
				>
					<PlaylistRemoveRoundedIcon fontSize="small" />
				</IconButton>
			</div> */}

			<Box
				className={[
					classes["box-program"],
					classes["printableGeralProgramaDiv"]
				]}
				id="printableGeralProgramaDiv"
			// mt={2}
			>
				<Box
					className={`${classes["fazenda-div"]} fazenda-div`}
					style={{
						backgroundColor: theme.palette.mode !== "dark" ? "#ffffff" : colors.blueOrigin[800], // força branco no modo escuro
					}}
				>
					<Typography
						className="print-fazenda-div"
						variant={!isCellPhone ? "h6" : "h6"}
						color={
							theme.palette.mode === "dark"
								? colors.primary[100]
								: "black"
						}
						sx={{
							display: "flex",
							flexDirection: "row",
							width: "100%",
							justifyContent: "space-between",
							paddingLeft: "5px",
							fontWeight: "bold"
						}}
					>
						<div style={{ fontFamily: "Times New Roman", fontStyle: 'italic' }}>
							até{" "}
							{finalDateForm && displayDate(finalDateForm)}
						</div>
						<div style={{ fontFamily: "Times New Roman", display: 'flex', flexDirection: 'row' }}>
							{farmSelected?.replace('Projeto', '')}
							<div
								className="print-safe-wrapper"
								style={{
									visibility: isGeneratingPDF ? "hidden" : "visible"
								}}
							>
								<FontAwesomeIcon
									icon={!onlyOpenApp ? faCheckDouble : faClock}
									color={
										!onlyOpenApp
											? colors.greenAccent[500]
											: colors.yellow[500]
									}
									size="sm"
									style={{
										margin: "0px 10px",
										cursor: "pointer"
									}}
									onClick={() => setOnlyOpenApp(!onlyOpenApp)}
								/>
								<FontAwesomeIcon
									icon={
										!filtData
											? faArrowDownShortWide
											: faArrowDownAZ
									}
									color={
										!filtData
											? colors.greenAccent[500]
											: colors.yellow[500]
									}
									size="sm"
									style={{
										margin: "0px 0px",
										cursor: "pointer"
									}}
									onClick={() => handleFilterTable()}
								/>
								{isLoadingHome ? (
									<CircularProgress
										size={15}
										sx={{
											margin: "0px 10px",
											color: (theme) =>
												colors.greenAccent[
												theme.palette.mode === "dark"
													? 200
													: 800
												]
										}}
									/>
								) : (
									<FontAwesomeIcon
										icon={faMapLocationDot}
										color={
											!showMapps
												? colors.greenAccent[500]
												: colors.yellow[500]
										}
										size="sm"
										style={{
											margin: "0px 10px",
											cursor: "pointer"
										}}
										onClick={() => handleShowMaps()}
									/>
								)}

								{/* {isLoadingHome ? (
								<CircularProgress
									size={15}
									sx={{
										margin: "0px 10px",
										color: (theme) =>
											colors.greenAccent[
												theme.palette.mode === "dark"
													? 200
													: 800
											]
									}}
								/>
							) : (
								<FontAwesomeIcon
									icon={faMapLocationDot}
									color={
										!showMapps
											? colors.greenAccent[500]
											: colors.yellow[500]
									}
									size="sm"
									style={{
										margin: "0px 10px",
										cursor: "pointer"
									}}
									onClick={() => handleRequestDjangoMaps()}
								/>
							)} */}

								{isAdminUser &&
									updateApp.length > 0 &&
									(sendingData ? (
										<CircularProgress
											size={15}
											sx={{
												margin: "0px 10px",
												color: (theme) =>
													colors.greenAccent[
													theme.palette.mode ===
														"dark"
														? 200
														: 800
													]
											}}
										/>
									) : (
										<IconButton
											aria-label="delete"
											onClick={() =>
												handleSendApiApp(updateApp)
											}
										>
											<FontAwesomeIcon
												icon={faCircleCheck}
												size="xs"
											/>
										</IconButton>
									))}

								{
									<Fade in={positiveSignal}>
										<FontAwesomeIcon
											icon={faCheck}
											size="xs"
											color={colors.greenAccent[500]}
										/>
									</Fade>
								}
							</div>
						</div>
						<div>
							{areaFiltTotal > 0 && (
								<div style={{ fontFamily: "Times New Roman" }}>
									&nbsp;&nbsp;&nbsp; Área:&nbsp;{" "}
									{areaFiltTotal.toLocaleString("pt-br", {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									})}
								</div>
							)}
						</div>
					</Typography>
				</Box>
				{objResumValues.length === 0 && <EmptyResultPage />}

				<Box className={classes["geral-program-div"]}>
					{objResumValues.length > 0 &&
						objResumValues.map((dat, i) => {
							const data = dat.data;
							const openApp = data.dataToFarmBox
							const programa = data.estagio.split("|")[1];
							const estagio = data.estagio.split("|")[0];
							const hiddenAppName =
								dat.data.estagio + farmSelected;

							const appLoading = isAppLoading(hiddenAppName);
							const appAlreadyOpened = appsOpened.includes(hiddenAppName);


							const totalToMult = Number(data.total.replace(/\./g, '').replace(',', '.'));
							const totaisFiltrados = dat.totais
								.sort((a, b) => a.tipo.localeCompare(b.tipo))
								.filter((t) => t.tipo !== "operacao");

							const totaisOrdenados = dat.totais.sort((a, b) => a.tipo.localeCompare(b.tipo));
							const totaisOperacao = totaisOrdenados.filter((t) => t.tipo === "operacao");
							const totaisNaoOperacao = totaisOrdenados.filter((t) => t.tipo !== "operacao");

							const extrasRender = prodsToAdd
								.filter((ex) => ex.appName === hiddenAppName)
								.map((ex) => {
									return {
										...ex.objToRender,
										qty: totalToMult * ex.objToRender.dose,
										canRemove: true
									}
								});
							const usandoAvulsa = !!useCaldaAvulsaByApp?.[hiddenAppName];

							const linhasParaMostrar = (() => {
								if (!usandoAvulsa) return [...totaisNaoOperacao, ...extrasRender];

								// ✅ em modo avulsa: mantém operação da calda antiga + mostra calda avulsa
								const avulsaRender = caldaAvulsa.map((x) => ({
									produto: x.produto,
									dose: Number(x.dosage_value),
									qty: totalToMult * Number(x.dosage_value),
									tipo: "avulsa",
									canRemove: false, // remove no modal
								}));

								// operação vem do dat.totais (já tem qty/dose prontos)
								const operacaoRender = totaisOperacao.map((t) => ({
									...t,
									canRemove: false, // não mexe aqui
								}));

								return [...operacaoRender, ...avulsaRender];
							})();

							// console.log('linhas para mostrar: ', linhasParaMostrar)
							// console.log('openApp: ', openApp)
							// console.log('openApp Cronograma: ', data.cronograma)



							return (
								<>
									<Box
										sx={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											width: '100%',
										}}
									>
										<IconButton
											onClick={() =>
												hiddenApps(
													hiddenAppName,
													data.total,
													data
												)
											}
											aria-label="delete"
											color="warning"
											sx={{
												alignSelf: "flex-end",
												borderRadius: "12px"
											}}
										>
											{!hidenAppsArr.includes(hiddenAppName) ?
												<VisibilityIcon color="success" fontSize="small" /> :
												<VisibilityOffIcon />
											}
											<Typography
												variant="h6"
												color={colors.textColor[100]}
												sx={{ marginLeft: '5px' }}
											>
												{estagio}
											</Typography>
										</IconButton>
										{isAdminUser &&
											!hidenAppsArr?.includes(hiddenAppName) &&
											(
												appLoading ? (
													<CircularProgress
														size={25}
														sx={{
															margin: "0px 10px",
															color: (theme) =>
																colors.greenAccent[
																theme.palette.mode === "dark"
																	? 200
																	: 800
																],
														}}
													/>
												) : (
													<Button
														onClick={() =>
															handleOpenApp(
																openApp,
																data.cronograma,
																estagio,
																data.estagio,
																hiddenAppName
															)
														}
														disabled={appAlreadyOpened}
														sx={{
															cursor: appAlreadyOpened
																? "not-allowed"
																: "pointer",
															width: "50px",
															height: "50px",

															"&.Mui-disabled": {
																backgroundColor:
																	"rgba(0,0,0,0.12)",
																opacity: 0.6,
																cursor: "not-allowed",

																"& img": {
																	filter:
																		"grayscale(100%)",
																	opacity: 0.4,
																},
															},
														}}
													>
														<img
															src={FarmIcon}
															alt="Abrir aplicação"
															style={{
																marginTop: "15px",
															}}
														/>
													</Button>
												)
											)
										}

									</Box >
									{appLoading && (
										<Box
											sx={{
												width: "100%",
												padding: "0px 10px",
											}}
										>
											<LinearProgress color="success" />
										</Box>
									)}									<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
										<Tooltip title={usandoAvulsa ? "Desativar Calda Avulsa" : "Usar Calda Avulsa neste card"}>
											<IconButton
												size="small"
												onClick={() => toggleUseCaldaAvulsa(hiddenAppName)}
												disabled={!caldaAvulsa.length}
												sx={{
													borderRadius: 2,
													backgroundColor: usandoAvulsa ? "rgba(76,175,80,0.15)" : "transparent",
												}}
											>
												<ContentPasteGoRoundedIcon
													fontSize="small"
													color={usandoAvulsa ? "success" : "inherit"}
												/>
											</IconButton>
										</Tooltip>

										<Tooltip title="Editar Calda Avulsa">
											<IconButton size="small" onClick={openMontarCalda}>
												<PlaylistAddRoundedIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									</Box>
									<div
										key={i}
										data-appname={hiddenAppName}  // <- adiciona isso aqui
										style={{
											boxShadow:
												"rgba(0, 0, 0, 0.5) 2px 2px 2px 1px",
											borderRadius: "8px",
											opacity: hidenAppsArr.includes(
												hiddenAppName
											)
												? "0"
												: "1",
											display: hidenAppsArr.includes(
												hiddenAppName
											)
												? "none"
												: "block",
											pageBreakInside: "avoid",
											breakInside: "avoid" // importante para navegadores modernos
										}}
										className={`${classes["mainProgramAllDiv"]} mainProgramAllDiv`}
									>

										<div
											key={i}
											style={{
												backgroundColor:
													colors.blueOrigin[800],
												border:
													theme.palette.mode ===
													"light" &&
													"1px solid black"
											}}
											className={
												classes[
												`${!isCellPhone
													? "detail-parcela-div-mobile"
													: "detail-parcela-div"
												}`
												]
											}
										><span
											style={{
												alignSelf: 'self-start',
												marginTop: '10px',
												marginLeft: '10px',
												fontWeight: 'bold',
												marginRight: '-40px',
											}}
										>
												{objResumValues.length - (i)} {" "}
											</span>
											<div
												className={
													!isNonIpad
														? classes[
														"estagio-div-ipad"
														]
														: classes["estagio-div"]
												}
											>
												<FontAwesomeIcon
													icon={
														!showProducts
															? faEyeSlash
															: faEye
													}
													color={
														!showProducts
															? colors
																.redAccent[500]
															: colors
																.greenAccent[500]
													}
													size="sm"
													style={{
														marginTop: "20px",
														cursor: "pointer"
													}}
													onClick={() =>
														setShoeProducts(
															!showProducts
														)
													}
												/>
												<p
													style={{
														color:
															theme.palette
																.mode ===
																"light"
																? "grey"
																: colors
																	.primary[300]
													}}
												>
													{programa}
												</p>
												<Box
													sx={{
														cursor: 'pointer',
														"& p:hover": {
															opacity: 0.5
														}
													}}
													onClick={() => data.cronograma
														.sort((a, b) =>
															!filtData
																? new Date(
																	a.dataPrevApp
																) -
																new Date(
																	b.dataPrevApp
																)
																: a.parcela.localeCompare(
																	b.parcela
																)
														).forEach(element => {
															// console.log(element.plantioId, element.estagio.split("|")[0])
															// console.log(element)
															handleSetAppMany(element.plantioId, element.estagio.split("|")[0], hiddenAppName, element.plantioIdFarmbox)
														})}
												>
													<p style={{ color: colors.primary[200] }}>{estagio}</p>
												</Box>
												<p
													style={{
														color:
															theme.palette
																.mode ===
																"light"
																? colors
																	.primary[100]
																: colors
																	.primary[100]
													}}
												>
													Área Total: {data.total}
												</p>
												<Zoom
													in={showProducts}
													style={{
														transitionDelay:
															showProducts
																? "300ms"
																: "0ms"
													}}
												>
													<div
														className={
															classes[
															"div-produtos-aplicar-outside"
															]
														}
													>
														{linhasParaMostrar
															.map((dataP, i) => {
																// console.log('dataP', dataP)
																const quantidade =
																	Number(
																		dataP.qty
																	).toLocaleString(
																		"pt-br",
																		{
																			maximumFractionDigits: 2,
																			minimumFractionDigits: 2
																		}
																	);
																const wasRemoved = prodsToRemove.filter((prodTo) => prodTo.appName === hiddenAppName && prodTo.prodToRemove.produto === dataP.produto && Number(prodTo?.prodToRemove?.dose).toFixed(3) === Number(dataP.dose).toFixed(3))
																if (wasRemoved.length > 0) {
																	console.log('wasRemoved', Number(wasRemoved[0]?.prodToRemove?.dose).toFixed(3) === Number(dataP.dose).toFixed(3))
																	console.log('dataP Dose', Number(dataP.dose).toFixed(3))
																}
																return (
																	<div
																		key={i}
																		style={{
																			height: "100%",
																			transition:
																				"height 3s",
																			display:
																				showProducts
																					? ""
																					: "none"
																		}}
																	>
																		<div
																			className={
																				classes[
																				"div-produtos-aplicar"
																				]
																			}
																		>
																			<div
																				style={{
																					textDecoration: wasRemoved.length > 0 && 'line-through',
																					color:
																						theme
																							.palette
																							.mode ===
																							"light"
																							? "black"
																							: colors
																								.primary[100]
																				}}
																				className={
																					classes[
																					"div-produtos-aplicar-produto"
																					]
																				}
																			>
																				<IconButton
																					onClick={() =>
																						!dataP.canRemove ?
																							handleDeleteProd(dataP, dat?.data?.produtos, hiddenAppName)
																							:
																							handleDeleteProdManual(dataP, hiddenAppName)
																					}
																					size="small"
																					aria-label="delete"
																					color={!wasRemoved.length > 0 ? "success" : 'error'}
																					sx={{
																						alignSelf: "start",
																						borderRadius: "12px"
																					}}
																					disabled={usandoAvulsa}
																				>
																					{
																						!dataP.canRemove ?
																							<DeleteIcon />
																							:
																							<DeleteForeverIcon color="warning" />

																					}
																				</IconButton>

																				{`${dataP.dose.toLocaleString(
																					"pt-br",
																					{
																						minimumFractionDigits: 3,
																						maximumFractionDigits: 3
																					}
																				)} - ` +
																					dataP.produto}
																			</div>
																			<div
																				style={{
																					color:
																						theme
																							.palette
																							.mode ===
																							"light"
																							? "black"
																							: colors
																								.primary[100]
																				}}
																				className={
																					classes[
																					"div-produtos-aplicar-quantidade"
																					]
																				}
																			>
																				{" "}
																				{
																					quantidade
																				}
																			</div>
																		</div>
																	</div>
																);
															})}
													</div>
												</Zoom>
												{
													isLoadingProdsToUse ?
														<CircularProgress size={24} color="inherit" />
														:
														<div
															className="print-safe-wrapper"
															style={{
																visibility: isGeneratingPDF ? "hidden" : "visible"
															}}
														>
															<IconButton
																size="small"
																color="success"
																onClick={() => handleAddProd(hiddenAppName, linhasParaMostrar, Number(dat?.data?.total?.replace(".", "").replace(",", ".")))}
																aria-label="adicionar"
																disabled={prodsToUse.length === 0 || usandoAvulsa}
																sx={{ marginBottom: '10px' }}
															>
																<AddCircleRoundedIcon fontSize="small" />
															</IconButton>
														</div>
												}
											</div>
											<div
												className={
													classes[
													"parcelas-resumo-div"
													]
												}
											>
												<div style={{ gap: "8px" }}>
													<div
														className={
															classes[
															"parcelas-div-header"
															]
														}
														style={{
															borderBottom: `0.5px dotted ${colors.primary[100]}`
														}}
													>
														<div
															style={{
																textAlign: 'left'
																// marginRight:
																// 	"20px"
															}}
														>
															Parcela
														</div>
														<div>Plantio</div>
														<div
														// style={{
														// 	marginRight:
														// 		"20px"
														// }}
														>
															Dap
														</div>
														<div
															// style={{
															// 	marginRight:
															// 		"30px"
															// }}
															className={
																classes[
																"cultura-div"
																]
															}
														>
															Cultura
														</div>
														<div>Variedade</div>
														<div
														// style={{
														// 	marginLeft:
														// 		"30px"
														// }}
														>
															Prev.
														</div>
														<div
														// style={{
														// 	marginLeft:
														// 		"20px"
														// }}
														>
															DAP AP
														</div>
														<div>Área</div>
													</div>
													{data.cronograma
														.sort((a, b) =>
															!filtData
																? new Date(
																	a.dataPrevApp
																) -
																new Date(
																	b.dataPrevApp
																)
																: a.parcela.localeCompare(
																	b.parcela
																)
														)
														.map((data, i) => {
															const dataId =
																data.plantioId;
															const setEstagio =
																data.estagio.split(
																	"|"
																)[0];

															const checkSelected =
																updateApp.some(
																	(data) =>
																		data.id ===
																		dataId &&
																		data.estagio ===
																		estagio
																);
															return (
																<div
																	key={i}
																	className={`${classes[
																		"parcelas-detail-div"
																	]
																		}
																	${checkSelected && classes["parcelas-resumo-div-selected"]}
																	${data.aplicado && classes["parcelas-resumo-div-aplicado"]}
																}
																	`}
																>
																	<div
																		className={
																			classes[
																			`${"parcela-div"}`

																			]
																		}
																	>
																		{(() => {
																			const occ = parcelasOcc?.[data.parcela];
																			const count = occ?.count || 0;
																			const duplicated = count > 1;

																			const sortedStages =
																				occ?.stages
																					?.slice()
																					?.sort((a, b) => (a.dapApp ?? 0) - (b.dapApp ?? 0)) || [];


																			const tooltipTitle = duplicated ? (
																				<Box sx={{ p: 1, minWidth: 320 }}>
																					<Box
																						sx={{
																							display: "flex",
																							alignItems: "center",
																							justifyContent: 'center',
																							marginBottom: '10px',
																							gap: 1,
																						}}
																					>
																						<Chip
																							label={data.parcela}
																							size="small"
																							color="warning"
																							sx={{
																								fontWeight: 800,
																								height: 22,
																								px: 0.5,
																								boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
																							}}
																						/>

																					</Box>


																					<Box
																						sx={{
																							display: "grid",
																							gridTemplateColumns: "1.7fr 2fr 0.5fr",
																							px: 0.75,
																							mb: 0.25,
																						}}
																					>
																						<Typography variant="caption" sx={{ fontWeight: 700 }}>
																							Estágio
																						</Typography>
																						<Typography variant="caption" sx={{ fontWeight: 700 }}>
																							Programa
																						</Typography>
																						<Typography variant="caption" sx={{ fontWeight: 700, marginLeft: 'auto' }}>
																							DAP
																						</Typography>
																					</Box>


																					<Divider sx={{ mb: 0.75 }} />

																					<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
																						{sortedStages.map((s, idx) => (
																							<Box
																								key={`${s.estagio}-${s.programa}-${idx}`}
																								sx={{
																									display: "grid",
																									gridTemplateColumns: "1.7fr 2fr 0.5fr",
																									alignItems: "center",
																									px: 0.75,
																									py: 0.4,
																									borderRadius: 0.75,
																									backgroundColor: idx % 2 === 0 ? "rgba(255,255,255,0.06)" : "transparent",
																								}}
																							>
																								{/* Estágio */}
																								<Typography variant="body2" sx={{ fontWeight: 500 }}>
																									{s.estagio || "-"}
																								</Typography>

																								{/* Programa */}
																								<Typography variant="body2" sx={{ opacity: 0.85 }}>
																									{s.programa.replace('Aplicação', '') || "-"}
																								</Typography>

																								{/* DAP */}
																								<Typography
																									variant="caption"
																									sx={{
																										fontWeight: 700,
																										ml: 1,
																										color: "warning.main",
																										whiteSpace: "nowrap",
																									}}
																								>
																									{s.dapApp != null ? `DAP ${s.dapApp}` : "-"}
																								</Typography>
																							</Box>
																						))}
																					</Box>

																					<Divider sx={{ mt: 0.75, mb: 0.5 }} />
																					<Box
																						sx={{
																							display: "flex",
																							alignItems: "center",
																							gap: 1.5,
																						}}
																					>
																						<Typography variant="caption" sx={{ opacity: 0.9 }}>
																							Ocorrências no período:
																						</Typography>

																						<Chip
																							label={`${count}x`}
																							size="small"
																							color="secondary"
																							sx={{
																								fontWeight: 700,
																								height: 20,
																							}}
																						/>
																					</Box>
																				</Box>
																			) : (
																				null
																			);

																			return (
																				<Tooltip title={tooltipTitle} arrow placement="left" componentsProps={{
																					tooltip: {
																						sx: {
																							maxWidth: 520, // controla largura máxima
																							minWidth: 400
																						},
																					},
																				}}>
																					<div
																						className={classes[`${"parcela-icon-div"}`]}
																						style={{ position: "relative" }}
																						onClick={() =>
																							handleSetApp(
																								dataId,
																								setEstagio,
																								hiddenAppName,
																								data.plantioIdFarmbox
																							)
																						}
																					>
																						{duplicated && count > 2 && (
																							<span
																								style={{
																									position: "absolute",
																									top: -6,
																									right: -12,
																									fontSize: 10,
																									lineHeight: "14px",
																									minWidth: 14,
																									height: 14,
																									padding: "0 4px",
																									borderRadius: 999,
																									background: "rgba(255,204,0,0.7)",
																									color: "#000",
																									fontWeight: 800,
																									boxShadow: "0 2px 6px rgba(0,0,0,0.35)",
																									display: "flex",
																									alignItems: "center",
																									justifyContent: "center",
																									pointerEvents: "none",
																								}}
																							>
																								{count}
																							</span>
																						)}

																						<img
																							src={filteredIcon(data)}
																							alt={filteredAlt(data)}
																							style={{
																								filter: "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))"
																							}}
																						/>
																						<span className={classes[`${hasduplicated(data.parcela) && "parcela-duplicated-" + theme.palette.mode}`]} style={{ fontWeight: 'bold', marginLeft: '10px' }}>
																							{
																								data.parcela
																							}
																						</span>
																					</div>

																				</Tooltip>
																			);
																		})()}
																	</div>
																	<div
																		style={{
																			color: colors
																				.greenAccent[300]
																		}}
																	>
																		{displayDate(
																			data.dataPlantio
																		)}
																	</div>
																	<div>
																		{data.dap <
																			10
																			? "0" +
																			data.dap
																			: data.dap}
																	</div>
																	<div
																		className={
																			classes[
																			"cultura-div"
																			]
																		}
																	>
																		{
																			data.cultura
																		}
																	</div>
																	<div
																		className={
																			classes[
																			"variedade-div"
																			]
																		}
																	>
																		{
																			data.variedade
																		}
																	</div>
																	<div>
																		{displayDate(
																			data.dataPrevApp
																		)}
																	</div>
																	<div>
																		{
																			data.dapApp
																		}
																	</div>
																	<div
																		style={{
																			color: colors
																				.primary[100],
																			fontWeight: 'bold'
																		}}
																		className={
																			classes[
																			"area-div"
																			]
																		}
																	>
																		{data.area
																			.toFixed(
																				2
																			)
																			.replace(
																				".",
																				","
																			)}
																	</div>
																</div>
															);
														})}
												</div>
											</div>
										</div>
										{/* <MapPlotDjango
											mapIdsFilter={mapIdsFilter}
											farmSelected={farmSelected}
											loadMaps={loadMaps}
											/> */}
										{showMapps && (
											<Box
												sx={{
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													borderRadius: "8px",
													backgroundColor:
														colors.blueOrigin[800]
												}}
												className={
													classes["geral-map-div"]
												}
											>
												<MapPage
													farmSelected={farmSelected}
													mapArray={mapArray}
													filtData={data}
												/>
											</Box>
										)}
									</div>
								</>
							);
						})}
					{objResumValues.length > 0 && (
						<Box
							id="footerDiv"
							sx={{ textAlign: 'center', marginTop: '10px' }}
						>
							<Divider>{farmSelected?.replace('Projeto', '')}</Divider>
						</Box>
					)}
				</Box>
			</Box>
			<Dialog open={openCaldaModal} onClose={closeMontarCalda} maxWidth="sm" fullWidth>
				<DialogTitle sx={{ fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
					Montar Calda Avulsa
					<Chip
						size="small"
						label={caldaSyncing ? "Salvando..." : "Sincronizada"}
						color={caldaSyncing ? "warning" : "success"}
						sx={{ fontWeight: 800 }}
					/>
				</DialogTitle>

				<DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1, mb: 2 }}>

					<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
						<Autocomplete
							size="small"
							options={prodsToUse}
							filterOptions={filterOptions}
							getOptionLabel={(opt) => opt.name}
							value={caldaProd}
							onChange={(_, v) => setCaldaProd(v)}
							renderInput={(params) => <TextField {...params} label="Insumo" />}
							sx={{ flex: 1 }}
						/>

						<TextField
							size="small"
							label="Dose"
							value={caldaDose}
							onChange={(e) => setCaldaDose(e.target.value)}
							placeholder="0.000"
							type="number"
							inputProps={{ step: 0.001, min: 0 }}
							sx={{ width: 140 }}
						/>

						<Button
							variant="contained"
							color="success"
							onClick={handleAddToCaldaAvulsa}
							disabled={!prodsToUse?.length}
							sx={{ fontWeight: 900, height: 40 }}
						>
							Adicionar
						</Button>
					</Box>

					<Divider />

					<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
						{caldaAvulsa.length === 0 ? (
							<Typography variant="body2" sx={{ opacity: 0.7 }}>
								Nenhum insumo na calda avulsa ainda.
							</Typography>
						) : (
							caldaAvulsa.map((x) => (
								<Box
									key={x.input_id}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										p: 1,
										borderRadius: 2,
										backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
									}}
								>
									<Box sx={{ display: "flex", flexDirection: "column" }}>
										<Typography sx={{ fontWeight: 800 }}>
											{Number(x.dosage_value).toLocaleString("pt-BR", {
												minimumFractionDigits: 3,
												maximumFractionDigits: 3,
											})}{" "}
											— {x.produto}
										</Typography>
										<Typography variant="caption" sx={{ opacity: 0.75 }}>
											{x.dosage_unity ? `Unidade: ${x.dosage_unity}` : "Unidade: -"}
										</Typography>
									</Box>

									<IconButton onClick={() => handleRemoveFromCaldaAvulsa(x.input_id)} color="error">
										<DeleteForeverIcon />
									</IconButton>
								</Box>
							))
						)}
					</Box>
				</DialogContent>

				<DialogActions sx={{ p: 2 }}>
					<Button onClick={handleClearCaldaAvulsa} disabled={!caldaAvulsa.length} color="warning">
						Limpar
					</Button>
					<Button onClick={closeMontarCalda} variant="contained">
						Fechar
					</Button>
				</DialogActions>
			</Dialog>

		</Box >
	);
};

export default DataProgramPage;
